import React from 'react';
import FotoUpload from './FotoUpload';

// Galeria de até `max` fotos da pergunta (adicionar/remover, compacta ao remover).
// Usada na pergunta marcada "Não" da Avaliação 360 (≥1 foto obrigatória — a
// obrigatoriedade é avisada por fora). Espelha o FotosResposta do BSV.
//
// Props:
//  - fotos: array de URLs (a fonte da verdade fica no pai)
//  - onChange(novaLista): recebe a lista já atualizada
//  - max: teto de fotos (default 3)
//  - loja, chave, prefixoSlot: metadados do nome do arquivo no SharePoint
const FotosResposta = ({ fotos, onChange, max = 3, loja, chave, prefixoSlot, placeholderVazio = null }) => {
  const lista = (fotos || []).filter(Boolean);

  const setAt = (idx, url) => {
    let nova = [...lista];
    if (url) nova[idx] = url;                       // troca a foto daquela posição
    else nova = nova.filter((_, i) => i !== idx);   // remover → compacta a lista
    onChange(nova);
  };
  const add = (url) => { if (url && lista.length < max) onChange([...lista, url]); };

  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center', justifyContent: 'flex-end' }}>
      {lista.map((u, i) => (
        <FotoUpload key={i} url={u} onUrl={(nu) => setAt(i, nu)}
          loja={loja} chave={chave} slot={`${prefixoSlot} ${i + 1}`} />
      ))}
      {lista.length < max && (
        <FotoUpload key={`add-${lista.length}`} url={''} label="+ Foto"
          onUrl={add} loja={loja} chave={chave} slot={`${prefixoSlot} ${lista.length + 1}`} />
      )}
      {lista.length === 0 && placeholderVazio && (
        <span style={{ fontSize: 12, color: '#94a3b8' }}>{placeholderVazio}</span>
      )}
    </div>
  );
};

export default FotosResposta;
